var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['navigation-row', {'selected': _vm.selected}],on:{"click":_vm.handleSelect}},[_c('div',{staticClass:"navigation-row-title"},[_vm._v(_vm._s(_vm.preparationArea.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }